import { render, staticRenderFns } from "./ModalCreateBannerSpace.vue?vue&type=template&id=4230e579&"
import script from "./ModalCreateBannerSpace.vue?vue&type=script&lang=js&"
export * from "./ModalCreateBannerSpace.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports